// 6) <App/> is the root component of our app. react-router lets you declare routes from anywhere in your component tree. We are  going to write most of our routes in the root app component.

import React from 'react';

// 7) First we import BrowserRouter and Route from react-router-dom.

// import {
//   BrowserRouter,
//   Route
// } from 'react-router-dom';

// 48) In order to render the NotFound component only when this route does not match a path we will have to use the react router switch component. So let's import switch from react-router-dom ...

import {
  BrowserRouter,
  Route,
  Switch
} from 'react-router-dom';


// 10) Now let's import our home component ...

import Home from './Home';

// 13) Now let's declare a route for the 'About' component by first importing the component ...

import About from './About';

// 16) Next let's make the header available to our entire app. First let's import Header ...

import Header from './Header';

// 17a) Now we will add the 'Teachers' and 'Courses' components ...

import Teachers from './Teachers';

import Courses from './Courses';

// 46) We want to implement a '404 page not found" feature. Currently when you type in a path that does not match any that are defined in your routes you get a blank page. We would like to instead dispay the NotFound.js route. So let's first import this file into App.js ...

import NotFound from './NotFound';

// 61) With react-router you are able to declare dynamic routes using special URL parameters. The data passed to your URL parameters can be displayed in you app. We can use URL parameters to create one route that matches a portion of a path dynamically. We can extract that data from the URL and render it inside the component. For example in this url: localhost:3000/teachers/JavaScript/Andrew ... We are going to extract the teachers name "Andrew" and his topic area "Javascript" from the URL and display it in a page rendered from the "Featured.js" component.

// 62) We are going to use the "Featured" component to render our URL parameters to the page. So first we must import that component ...

import Featured from './Featured';

// const App = () => (
//   <div className="container">
//   </div>
// );

// 8) You begin declaring routes by rendering a router that wraps all you app components using the BrowserRouter tag. This renders the route router that listens to URL Changes, and provides other react-router components information about the current URL and which components to be rendered. This way the UI is always in sync with the URL.

// const App = () => (
//   <BrowserRouter>
//     <div className="container">
//     </div>
//   </BrowserRouter>
// );

// 9) Normally you would render a nested component like below. (If you are getting an error in your browser that is because we have not imported our home component.)

// const App = () => (
//   <BrowserRouter>
//     <div className="container">
//       <Home/>
//     </div>
//   </BrowserRouter>
// );

// 11) With react-router you  would create a route for the home component like below. The 'path' property indicates the URL to match, and the 'component' property specifies which component to render when the URL matches the path property.

// 12) ??? The best part about working with react-router is that, since you are working with regular components, where ever you declare a route, the component the route renders automatically becomes a nested component in your UI. In other words any route you write in the App container will render a child component when its path matches the URL ???

// const App = () => (
//   <BrowserRouter>
//     <div className="container">
//     <Route path="/" component={Home} />
//     </div>
//   </BrowserRouter>
// );

// 14) Now let's add the about component to our App JSX ...

// const App = () => (
//   <BrowserRouter>
//     <div className="container">
//      <Route path="/" component={Home} />
//      <Route path="/about" component={About} />
//     </div>
//   </BrowserRouter>
// );

// 15) Now When you add the /about path to the URL both the 'Home' and the 'About' components get rendered inside APP. This happens because both paths begin with a '/'. To fix this we will have to add the exact property to the 'Home' route.

// const App = () => (
//   <BrowserRouter>
//     <div className="container">
//      <Route exact path="/" component={Home} />
//      <Route path="/about" component={About} />
//     </div>
//   </BrowserRouter>
// );

// 17b) Since our header needs to visible at all times, we will nest it inside the app just above the routes ...

// const App = () => (
//   <BrowserRouter>
//     <div className="container">
//       <Header />
//       <Route exact path="/" component={Home} />
//       <Route path="/about" component={About} />
//     </div>
//   </BrowserRouter>
// );

// 18) And then we add the 'Teachers' and 'Courses' routes to our 'App' component ...

// const App = () => (
//   <BrowserRouter>
//     <div className="container">
//       <Header />
//       <Route exact path="/" component={Home} />
//       <Route path="/about" component={About} />
//       <Route path="/teachers" component={Teachers} />
//       <Route path="/courses" component={Courses} />
//     </div>
//   </BrowserRouter>
// );

// 19) So now  we want to change the 'about' route to do inline component rendering ... 'component={About}' becomes 'render={ () = <About/> }' ...

// const App = () => (
//   <BrowserRouter>
//     <div className="container">
//       <Header />
//       <Route exact path="/" component={Home} />
//       <Route path="/about" render={ () => <About/> } />
//       <Route path="/teachers" component={Teachers} />
//       <Route path="/courses" component={Courses} />
//     </div>
//   </BrowserRouter>
// );

// 20) We do this when we want to pass props to the component we are rendering. Below we  are passing the title prop to the about component. See below then go to  ((About.js)) ...

// const App = () => (
//   <BrowserRouter>
//     <div className="container">
//       <Header />
//       <Route exact path="/" component={Home} />
//       <Route path="/about" render={ () => <About title='About' /> } />
//       <Route path="/teachers" component={Teachers} />
//       <Route path="/courses" component={Courses} />
//     </div>
//   </BrowserRouter>
// );

// 47) Then in our routes we add a new route component below all the opther routes. This path will not specify a route, just a path (NotFound). Because this  route does not have a path it will always render on every route ...

// const App = () => (
//   <BrowserRouter>
//     <div className="container">
//       <Header />
//       <Route exact path="/" component={Home} />
//       <Route path="/about" render={ () => <About title='About' /> } />
//       <Route path="/teachers" component={Teachers} />
//       <Route path="/courses" component={Courses} />
//       <Route component={NotFound} />
//     </div>
//   </BrowserRouter>
// );

// 49) Now we wrap all of our routes in our Switch component. Switch will only render the first route that matches the URL. For example at the /Teachers path switch looks for a route component that matches that path. And if the first one that matches it will render a component then Switch stops looking for matches. And if Switch does not find a matching route it is going to fall back to this catch-all route, and render the 'NotFound' Component.

// 50) Now we want to refactor our code. The CSS, HTML, and JavaScript components all share the same behavior. They render data from the arrays in the data/courses.js. file. To do this we will combine all three files (CSS.js, HTML.js, and JavaScript.js) into one file and then we will combine all three routes in the Courses component (Courses.js) into one route ... So let's first copy one of these three files to be the template for our new page. I will copy the HTML.js file and rename it CourseContainer.js. Do this then ((Go to CourseContainer.js))

// const App = () => (
//   <BrowserRouter>
//     <div className="container">
//       <Header />
//       <Switch>
//         <Route exact path="/" component={Home} />
//         <Route path="/about" render={ () => <About title='About' /> } />
//         <Route path="/teachers" component={Teachers} />
//         <Route path="/courses" component={Courses} />
//         <Route component={NotFound} />
//       </Switch>
//     </div>
//   </BrowserRouter>
// );

// 63) Then we add a new route in switch right below the teachers route. The path will also be "/teachers" but the component will be "Featured". We also need to add the "exact" attribute to the original teachers route path. Now if you include a sub-path in the teachers URL the "Featured component will render.

// const App = () => (
//   <BrowserRouter>
//     <div className="container">
//       <Header />
//       <Switch>
//         <Route exact path="/" component={Home} />
//         <Route path="/about" render={ () => <About title='About' /> } />
//         <Route exact path="/teachers" component={Teachers} />
//         <Route path="/teachers" component={Featured} />
//         <Route path="/courses" component={Courses} />
//         <Route component={NotFound} />
//       </Switch>
//     </div>
//   </BrowserRouter>
// );

// 64) To display content to the app from content in the URL we need to add url parameters. We define url parameters in a route path using a colon. See below then ((go to Featured.js))

// const App = () => (
//   <BrowserRouter>
//     <div className="container">
//       <Header />
//       <Switch>
//         <Route exact path="/" component={Home} />
//         <Route path="/about" render={ () => <About title='About' /> } />
//         <Route exact path="/teachers" component={Teachers} />
//         <Route path="/teachers/:topic/:name" component={Featured} />
//         <Route path="/courses" component={Courses} />
//         <Route component={NotFound} />
//       </Switch>
//     </div>
//   </BrowserRouter>
// );

// 70) You can also separate URL parameters with a dash. To dipay a teachers first and last name we will change name paramter to "/teachers/:topic/:fname-:lname". See below then ((go to featured component)).

const App = () => (
  <BrowserRouter basename="/projects/react/react-router-demo">
    <div className="container">
      <Header />
      <Switch>
        <Route exact path="/" component={Home} />
        <Route path="/about" render={ () => <About title='About' /> } />
        <Route exact path="/teachers" component={Teachers} />
        <Route path="/teachers/:topic/:fname-:lname" component={Featured} />
        <Route path="/teachers/:topic/:name" component={Featured} />
        <Route path="/courses" component={Courses} />
        <Route component={NotFound} />
      </Switch>
    </div>
  </BrowserRouter>
);

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js